import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IFlujoLightTXAttachedFileUpload, IFlujoLightTXNewStage, IFlujoLightTXDecision, IFlujoLightTXFileListResponse, IFlujoLightTXPaginated, IFlujoLightTXPermissions, IFlujoLightTXQueryParams, IFlujoLightTXRawPaginatedResponse, IFlujoLightTXTransactionStatusRaw, IFlujoLightTXUploadFileResponse, IFlujoLightTXCurrentStage, IFlujoLightTXDeleteFileRequest, IReporteConsolidado, IReporteConsolidadoRaw, IApprovalFlow, IGeneralReportRaw, IGeneralReport, IApprovalFlowResponse, IApplicationRaw, IMainApplicationRaw, IRulesInputRaw, IContractRaw, IRuleEngineField } from 'src/app/interface/IFlujoLightTx';
import { environment as env } from '../../../environments/environment';
import { SessionService } from './session.service';
import { map } from 'rxjs/operators';
import { IUserInfoCognito } from './cognito.service';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class FlujoCreditoLightService {
    private endpointReporteConsolidado: string = env.backend.reporteConsolidado.url;
    private endpointFlujoCreditoLight: string = env.backend.flujoCreditoLight.url;
    private modeloSeleccionado: string | null = null;
    private modeloNotFound = false;

    constructor(private http: HttpClient, private _sessionService: SessionService) {
        this.getTransactions();
    }

    setModelo(modelo: string): void {
        this.modeloSeleccionado = modelo;
    }

    getModelo(): string | null {
        return this.modeloSeleccionado;
    }

    getModeloNotFound(): boolean {
        return this.modeloNotFound;
    }

    setModeloNotFound(status: boolean): void {
        this.modeloNotFound = status;
    }


    clear(): void {
        this.modeloSeleccionado = null;
    }

    private getHeaders(idOrganizacion: string, idUsuario: string, requestOrigin: string): HttpHeaders {
        const headers = new HttpHeaders()
            .set("IDOrganizacion", idOrganizacion)
            .set("IDUsuario", idUsuario)
            .set("requestOrigin", requestOrigin)

        return headers
    }

    buildHttpParams(paramsObj?: Record<string, string | null | undefined>): HttpParams {
        let params = new HttpParams();

        if (!paramsObj) return params;

        for (const [key, value] of Object.entries(paramsObj)) {
            if (value != null && value !== '') {
                params = params.set(key, value);
            }
        }

        return params;
    }


    getTransactionsStatuses(): Observable<IFlujoLightTXTransactionStatusRaw[]> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');

        return this.http.get<IFlujoLightTXTransactionStatusRaw[]>(`${this.endpointFlujoCreditoLight}statuses`, { headers });
    }

    getDecisions(model: string): Observable<IFlujoLightTXDecision[]> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');
        const params = this.buildHttpParams({ model, idOrganizacion });

        return this.http.get<IFlujoLightTXDecision[]>(`${this.endpointFlujoCreditoLight}decisions`, { headers, params });
    }

    getPermissions(): Observable<IFlujoLightTXPermissions[]> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo()
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');

        return this.http.get<IFlujoLightTXPermissions[]>(`${this.endpointFlujoCreditoLight}models/permissions`, { headers });
    }

    getTransactions(queryParams: IFlujoLightTXQueryParams = {}): Observable<IFlujoLightTXPaginated> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo()
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');
        const params = this.buildHttpParams({ ...queryParams });

        return this.http.get<IFlujoLightTXRawPaginatedResponse>(`${this.endpointReporteConsolidado}reports`, { headers, params }).pipe(
            map(response => this.mapFlujoLightTX(response))
        );
    }

    getGeneralReport(idTransaccion: string): Observable<IGeneralReport> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');

        const params = this.buildHttpParams({ idOrganizacion, idTransaccion });

        return this.http.get<IGeneralReportRaw>(`${this.endpointReporteConsolidado}report`, { headers, params }).pipe(
            map(rawData => this.mapReporte(rawData))
        );
    }

    safeParseDate(value?: string): Date | null {
        if (!value) return null;

        const date = new Date(value);
        return isNaN(date.getTime()) ? null : date;
    }

    mapReporte(rawData: IGeneralReportRaw): IGeneralReport {
        const {
            DatosBasicosSolicitud,
            Calculos,
            rulesInput = {} as Partial<IRulesInputRaw>,
            isAutomaticDecision
        } = rawData.ReporteConsolidado

        const { Resultado } = Calculos;

        const {
            application = {} as Partial<IMainApplicationRaw>,
            applications = [],
            activeContracts = [],
        } = rulesInput;

        return {
            datosBasicosSolicitud: {
                rut: DatosBasicosSolicitud.Rut,
                modelo: DatosBasicosSolicitud.Modelo,
                estadoTransaccion: DatosBasicosSolicitud.EstadoTransaccion,
            },
            calculos: {
                resultado: {
                    resolucion: Resultado.resolucion,
                    mensaje: Resultado.mensaje,
                    carga: Resultado.carga || 0,
                    mensajegarcarga: Resultado.mensajegarcarga,
                    deudamorosa: Resultado.deudamorosa || 0,
                    regcheq: Resultado.regcheq,
                    antiguedad: Resultado.antiguedad || 0,
                    montomaxUF: Resultado.montomaxUF || 0,
                    deudabancaria: Resultado.deudabancaria || 0,
                    deudasbif: Resultado.deudasbif || 0,
                    deudasbifship: Resultado.deudasbifship || 0,
                    deudasbifshipRenta: Resultado.deudasbifshipRenta || 0,
                    rentaactual: Resultado.rentaactual || 0,
                    tiporenta: Resultado.tiporenta,
                    lineabancaria: Resultado.lineabancaria || 0,
                    tagratio: Resultado.tagratio || 0,
                    // Las siguientes propiedades no pueden tener un 0 por defecto
                    // porque hay condiciones que implican que 0 es OK,
                    // sino es NO OK y por lo tanto estaría forzando un OK
                    cargasem: Resultado.cargasem,
                    deudamorosasem: Resultado.deudamorosasem,
                    tagsem: Resultado.tagsem,
                    lineabancariasem: Resultado.lineabancariasem,
                    deudabancariasem: Resultado.deudabancariasem,
                    deudasbifshipRentasem: Resultado.deudasbifshipRentasem,
                    antiguedasem: Resultado.antiguedasem,
                    deudasalfasem: Resultado.deudasalfasem
                },
            },
            rulesInput: {
                application: {
                    income: parseInt(application.income?.trim() || "0"),
                    amount: parseInt(application.amount?.trim() || "0"),
                    currency: application.currency || '',
                    createdAt: this.safeParseDate(application.createdAt?.date),
                    carName: application.carName || '',
                    period: parseInt(application.period?.trim() || "0"),
                    kilometers: parseInt(application.kilometers?.trim() || "0")
                },
                applications: applications.map((application: IApplicationRaw) => ({
                    amount: parseInt(application.amount?.trim() || "0"),
                    currency: application.currency || '',
                    status: application.status || '',
                    createdAt: this.safeParseDate(application.createdAt.date),
                    carName: application.carName || '',
                    period: parseInt(application.period?.trim() || "0"),
                    kilometers: parseInt(application.kilometers?.trim() || "0")
                })),
                activeContracts: activeContracts.map((contract: IContractRaw) => ({
                    status: contract.status || '',
                    startDate: this.safeParseDate(contract.startDate),
                    amount: parseInt(contract.amount?.trim() || "0"),
                    period: parseInt(contract.period?.trim() || "0"),
                }))
            },
            isAutomaticDecision: isAutomaticDecision === 'true',
        };
    }

    
    getReportByServiceKey(idTransaccion: string, serviceKey: string): Observable<any> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');

        const params = this.buildHttpParams({ idTransaccion, serviceKey });

        return this.http.get<any>(`${this.endpointReporteConsolidado}report/service`, { headers, params });
    }

    getApprovalFlow(idTransaccion: string): Observable<IApprovalFlowResponse> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');
        const params = this.buildHttpParams({ idTransaccion });

        return this.http.get<IApprovalFlowResponse>(`${this.endpointFlujoCreditoLight}approvalFlow`, { headers, params });
    }

    createApprovalFlow(data: {model: string, idTransaccion: string}): Observable<any> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');

        return this.http.post<any>(`${this.endpointFlujoCreditoLight}approvalFlow`, data, { headers });
    }

    updateApprovalFlow(data: IApprovalFlow): Observable<any> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');

        data.atributos.usuarioApruebaRechaza = idUsuario;
        data.envioOwnerTransaccionFlujoCredito = { envio: idUsuario, tipo: 'CORREO' };

        return this.http.post<any>(`${this.endpointFlujoCreditoLight}approvalFlow/update`, data, { headers });
    }

    mapReporteConsolidado(rawData: IReporteConsolidadoRaw): IReporteConsolidado {
        const { DatosBasicosSolicitud } = rawData.ReporteConsolidado;

        return {
            modelo: DatosBasicosSolicitud.Modelo
        }
    }

    mapFlujoLightTX(rawData: IFlujoLightTXRawPaginatedResponse): IFlujoLightTXPaginated {
        return {
            transactions: rawData.transactions.map(({ DatosBasicosSolicitud, Reporte }) => ({
                rut: `${DatosBasicosSolicitud.Rut}-${DatosBasicosSolicitud.DV}`,
                nombre: Reporte.name,
                decision: Reporte.decision,
                estado: DatosBasicosSolicitud.EstadoTransaccion,
                fecha: new Date(DatosBasicosSolicitud.FechaReporte),
                idTransaccion: DatosBasicosSolicitud.IDTransaccion,
                auto: Reporte.isAutomaticDecision === 'true',
                estaCerrada: Reporte.isTransactionClosed === 'true'
            })),
            encodedCursor: rawData.encodedCursor
        }
    }

    uploadFile(data: IFlujoLightTXAttachedFileUpload): Observable<IFlujoLightTXUploadFileResponse> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');

        return this.http.post<IFlujoLightTXUploadFileResponse>(`${this.endpointFlujoCreditoLight}attachedFile`, data, { headers });
    }

    getAttachedFiles(idTransaccion: string): Observable<IFlujoLightTXFileListResponse> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');

        const params = new HttpParams()
            .set('idTransaccion', idTransaccion);

        return this.http.get<IFlujoLightTXFileListResponse>(`${this.endpointFlujoCreditoLight}attachedFiles`, { headers, params });
    }

    deleteAttachedFile(fileData: IFlujoLightTXDeleteFileRequest): Observable<any> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');

        return this.http.post(`${this.endpointFlujoCreditoLight}attachedFile/delete`, fileData, { headers });
    }

    getCurrentStage(idTransaccion: string): Observable<IFlujoLightTXCurrentStage> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');

        const params = new HttpParams()
            .set('idTransaccion', idTransaccion);

        return this.http.get<IFlujoLightTXCurrentStage>(`${this.endpointFlujoCreditoLight}stage`, { headers, params }).pipe(
            map(response => ({
                idTransaccion,
                currentStage: response.currentStage
            }))
        );
    }

    createStage(stageData: IFlujoLightTXNewStage): Observable<any> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');

        return this.http.post(`${this.endpointFlujoCreditoLight}stage`, stageData, { headers });
    }

    getRuleEngineFields(idTransaccion: string, model: string): Observable<IRuleEngineField[]> {
        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');
        const params = this.buildHttpParams({ idTransaccion, model });

        return this.http.get<IRuleEngineField[]>(`${this.endpointFlujoCreditoLight}ruleEngine/fields`, { headers, params });
    }

}
